import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Components :Bronto direct add
 * ------------------------------------------------------------------------------
 * Modular component used to add the bronto direct add snippet to newsletter forms.
 *
 */

import { on } from '~/helpers/utils';
import cssClasses from '~/helpers/cssClasses';
/**
* DOM selectors.
*/

const selectors = {
  email: '[js-direct-add="email"]',
  form: '[js-direct-add="form"]',
  submit: '[js-direct-add="submit"]',
  feedback: '[js-direct-add="feedback"]'
};
/**
 * Run direct add script.
 */

export default (() => {
  const form = document.querySelectorAll(selectors.form);
  /**
   * Initialise login form.
   */

  function init() {
    if (!theme.strings.brontoDirectAdd || form.length === 0) {
      return;
    }

    setEventListeners();
  }

  function formSubmitHandler(formElement) {
    const nodeSelectors = {
      form: formElement.querySelector(selectors.form),
      email: formElement.querySelector(selectors.email),
      submit: formElement.querySelector(selectors.submit),
      feedback: formElement.querySelector(selectors.feedback)
    };
    on('submit', formElement, event => {
      event.preventDefault();
      const brontoImage = new Image();
      brontoImage.src = theme.strings.brontoDirectAdd.replace(/\[userMail\]/g, nodeSelectors.email.value);
      nodeSelectors.submit.classList.add(cssClasses.loading);

      brontoImage.onload = () => {
        event.target.submit();
      };

      brontoImage.onerror = () => {
        nodeSelectors.submit.classList.remove(cssClasses.loading);
        nodeSelectors.submit.classList.add(cssClasses.disabled);
        nodeSelectors.submit.setAttribute('disabled', 'disabled');
        nodeSelectors.feedback.innerHTML = "\n          <p class=\"template-register__error\">\n            ".concat(theme.strings.customer.registerError, "\n          </p>\n        ");
      };

      document.body.appendChild(brontoImage);
    });
  }

  function setEventListeners() {
    [...form].forEach(formElement => {
      formSubmitHandler(formElement);
    });
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});